/*
 * Fall Sale 2 — interactions for fs2-* sections.
 * Every section loads this file; the guard keeps it to a single run.
 */
(function () {
  if (window.FallSale2) return;

  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function isMobile() {
    return mobileQuery.matches;
  }

  /* Focus: mouse/pen drag-to-scroll on the mobile product tracks */
  function initDragTrack(track) {
    var active = null;
    var blockClick = false;

    function onPointerMove(event) {
      if (!active || !isMobile()) return;

      var deltaX = event.clientX - active.startX;
      var deltaY = event.clientY - active.startY;

      if (!active.committed) {
        if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
        if (Math.abs(deltaY) >= Math.abs(deltaX)) {
          endDrag(event);
          return;
        }
        active.committed = true;
        track.classList.add('is-dragging');
        try {
          track.setPointerCapture(event.pointerId);
        } catch (err) {}
      }

      event.preventDefault();
      if (Math.abs(deltaX) > 4) active.dragged = true;
      track.scrollLeft = active.startScroll - deltaX;
    }

    function endDrag(event) {
      if (!active) return;
      if (active.dragged) blockClick = true;

      try {
        if (event && track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
      } catch (err) {}

      track.classList.remove('is-dragging');
      active = null;
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
    }

    track.addEventListener('pointerdown', function (event) {
      if (!isMobile()) return;
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('button, a, input, select, label, form')) return;

      active = {
        startX: event.clientX,
        startY: event.clientY,
        startScroll: track.scrollLeft,
        dragged: false,
        committed: false,
      };

      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
    });

    track.addEventListener(
      'click',
      function (event) {
        if (!blockClick) return;
        event.preventDefault();
        event.stopPropagation();
        blockClick = false;
      },
      true
    );
  }

  /* Focus / Essentials: Swiper carousel with a draggable progress bar (layout = carousel) */
  var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  function loadSwiper(callback) {
    if (window.Swiper) {
      callback();
      return;
    }
    var script = document.querySelector('script[src="' + SWIPER_SRC + '"]');
    if (!script) {
      script = document.createElement('script');
      script.src = SWIPER_SRC;
      document.head.appendChild(script);
    }
    script.addEventListener('load', function () {
      if (window.Swiper) callback();
    });
  }

  function initSwiper(container) {
    var scrollbar = container.parentElement.querySelector('[data-fs2-swiper-scrollbar]');
    var gap = parseFloat(container.getAttribute('data-gap')) || 0;
    var gapMobile = parseFloat(container.getAttribute('data-gap-mobile')) || 0;

    // The carousel is full-bleed; the gutter is the distance from its left edge to the
    // content edge of its parent (where the title starts). CSS reads it as --fs2-gutter.
    var bleed = container.closest('.fs2-carousel') || container;

    function gutter() {
      var parent = bleed.parentElement;
      var style = getComputedStyle(parent);
      var value = Math.max(
        0,
        parent.getBoundingClientRect().left +
          parseFloat(style.paddingLeft) +
          parseFloat(style.borderLeftWidth) -
          bleed.getBoundingClientRect().left
      );
      bleed.style.setProperty('--fs2-gutter', value + 'px');
      return value;
    }

    gutter();
    window.addEventListener('resize', gutter);

    // Swiper cancels the click of a focused button on any mouse move while pressed, so a
    // slightly shaky click on Add to Cart did nothing. Mouse presses on a button drop its
    // focus first (the cart drawer hands focus back to it on close) and don't focus it.
    // Touch and keyboard are untouched.
    var mousePress = false;
    container.addEventListener('pointerdown', function (event) {
      var button = event.target.closest('button');
      mousePress = event.pointerType === 'mouse' && event.button === 0 && !!button;
      if (mousePress && button.contains(document.activeElement)) document.activeElement.blur();
    }, true);
    container.addEventListener('mousedown', function (event) {
      if (mousePress) event.preventDefault();
    }, true);

    loadSwiper(function () {
      if (container.swiper) return;
      var offset = gutter();
      new window.Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: gapMobile,
        slidesOffsetBefore: offset,
        slidesOffsetAfter: offset,
        grabCursor: true,
        watchOverflow: true,
        // Movement before a press counts as a swipe (default 5px); more room for clicks
        threshold: 10,
        breakpoints: {
          769: { spaceBetween: gap },
        },
        scrollbar: scrollbar ? { el: scrollbar, draggable: true } : false,
        on: {
          beforeResize: function (swiper) {
            swiper.params.slidesOffsetBefore = swiper.params.slidesOffsetAfter = gutter();
          },
        },
      });
    });
  }

  /* Focus / Essentials: in-card variant dropdown (snippets/fs2-variant-picker.liquid) */
  function initVariantPicker(picker) {
    var select = picker.querySelector('[data-fs2-variant-select]');
    var value = picker.querySelector('[data-fs2-variant-value]');
    var card = picker.closest('.fs2-card, .fs2-focus-card');
    var price = card && card.querySelector('[data-fs2-price]');
    var image = card && card.querySelector('.fs2-card__media img, .fs2-focus-card__media img');
    // Product image, for variants without an image of their own
    var original = picker.hasAttribute('data-image')
      ? {
          src: picker.getAttribute('data-image'),
          srcset: picker.getAttribute('data-srcset'),
          alt: picker.getAttribute('data-alt'),
        }
      : image && { src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), alt: image.getAttribute('alt') };
    if (!select) return;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      var form = document.getElementById(picker.getAttribute('data-form'));
      var input = form && form.querySelector('input[name="id"]');
      if (input) input.value = option.value;
      if (value) value.textContent = option.getAttribute('data-title');

      if (price) {
        // Classes come from the card's price element, e.g. fs2-card__price → fs2-card__price-sale
        var base = price.classList[0];
        var compare = option.getAttribute('data-compare');
        price.innerHTML =
          '<span class="' + base + '-sale">' + option.getAttribute('data-price') + '</span>' +
          (compare ? '<span class="' + base + '-compare">' + compare + '</span>' : '');
      }

      if (image) {
        var src = option.getAttribute('data-image');
        var next = src
          ? { src: src, srcset: option.getAttribute('data-srcset'), alt: option.getAttribute('data-alt') }
          : original;
        if (next.srcset) image.setAttribute('srcset', next.srcset);
        else image.removeAttribute('srcset');
        image.setAttribute('src', next.src);
        if (next.alt !== null) image.setAttribute('alt', next.alt);
      }
    });
  }

  /* Essentials: mobile "View More / View Less" */
  function initViewMore(root) {
    var grid = root.querySelector('[data-fs2-essentials-grid]');
    var btn = root.querySelector('[data-fs2-view-more]');
    if (!grid || !btn) return;

    btn.addEventListener('click', function () {
      var expanded = grid.classList.toggle('is-expanded');
      btn.classList.toggle('is-expanded', expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = btn.querySelector('[data-fs2-view-more-label]');
      if (label) {
        label.textContent = expanded ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
      }
    });
  }

  /* Blog: arrow-controlled scroll carousel on mobile */
  function initBlogCarousel(carousel) {
    var track = carousel.querySelector('.fs2-blog__cards');
    if (!track) return;
    var cards = Array.from(track.children);
    var prev = carousel.querySelector('.fs2-blog__arrow--prev');
    var next = carousel.querySelector('.fs2-blog__arrow--next');
    var media = carousel.querySelector('.fs2-blog__card-media');
    var targetIndex = null;
    if (!prev || !next || !cards.length) return;

    function nearestIndex() {
      return cards.reduce(function (best, card, index) {
        return Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - track.scrollLeft)
          ? index
          : best;
      }, 0);
    }

    function update() {
      var scrollable = track.classList.contains('fs2-blog__cards--scroll');
      var overflow = scrollable && cards.length > 1 && track.scrollWidth > track.clientWidth + 1;
      prev.hidden = next.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }

    function move(direction) {
      targetIndex = Math.max(
        0,
        Math.min(cards.length - 1, (targetIndex === null ? nearestIndex() : targetIndex) + direction)
      );
      track.scrollTo({
        left: cards[targetIndex].offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    prev.addEventListener('click', function () {
      move(-1);
    });
    next.addEventListener('click', function () {
      move(1);
    });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('pointerdown', function () {
      targetIndex = null;
    });
    track.addEventListener('scrollend', function () {
      targetIndex = null;
    });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        targetIndex = null;
        if (media) {
          carousel.style.setProperty('--fs2-blog-media-bottom', media.offsetTop + media.offsetHeight + 'px');
        }
        update();
      });
      observer.observe(track);
      if (media) observer.observe(media);
    }
    update();
  }

  /* Trust: one-slide-at-a-time swipe carousel on mobile */
  function initTrust(root) {
    var carousel = root.querySelector('[data-fs2-trust-carousel]');
    if (!carousel) return;
    var viewport = carousel.querySelector('[data-fs2-trust-viewport]');
    var track = carousel.querySelector('[data-fs2-trust-track]');
    var dots = carousel.querySelectorAll('[data-fs2-trust-dot]');
    var slides = carousel.querySelectorAll('.fs2-trust__slide');
    if (!viewport || !track || !slides.length) return;

    var index = 0;
    var drag = null;
    var autoplay = parseInt(carousel.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    var SWIPE_THRESHOLD = 40;

    function setTransform(i, offsetPx) {
      var w = viewport.clientWidth || 1;
      track.style.transform = 'translate3d(' + (-(i * w) + (offsetPx || 0)) + 'px, 0, 0)';
    }

    function goTo(i, animate) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      index = i;
      track.style.transition = animate === false ? 'none' : '';
      setTransform(index, 0);
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === index);
        dot.setAttribute('aria-selected', j === index ? 'true' : 'false');
      });
      if (animate === false) {
        requestAnimationFrame(function () {
          track.style.transition = '';
        });
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplay > 0 && slides.length > 1) {
        timer = setInterval(function () {
          if (isMobile() && !drag) goTo(index + 1);
        }, autoplay * 1000);
      }
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(i)) goTo(i);
        startAutoplay();
      });
    });

    function onPointerMove(event) {
      if (!drag || !isMobile()) return;
      event.preventDefault();
      drag.lastX = event.clientX;
      setTransform(drag.startIndex, drag.lastX - drag.startX);
    }

    function endDrag(event) {
      if (!drag) return;
      var dx = drag.lastX - drag.startX;

      try {
        if (event && viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }
      } catch (err) {}

      viewport.classList.remove('is-dragging');
      track.style.transition = '';
      if (Math.abs(dx) >= SWIPE_THRESHOLD) {
        goTo(dx < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }

      drag = null;
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
      startAutoplay();
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (!isMobile()) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      drag = { startX: event.clientX, lastX: event.clientX, startIndex: index };
      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
      try {
        viewport.setPointerCapture(event.pointerId);
      } catch (err) {}

      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
    });

    // A wrapped title keeps its box at max-width, leaving space on the right; shrink the
    // text box to its longest line so icon + text look centred.
    function fitCopy() {
      carousel.querySelectorAll('.fs2-trust__copy').forEach(function (copy) {
        copy.style.width = '';
        var widest = 0;
        var range = document.createRange();
        Array.prototype.forEach.call(copy.children, function (line) {
          range.selectNodeContents(line);
          Array.prototype.forEach.call(range.getClientRects(), function (rect) {
            widest = Math.max(widest, rect.width);
          });
        });
        if (widest) copy.style.width = Math.ceil(widest) + 'px';
      });
    }

    window.addEventListener('resize', function () {
      if (isMobile()) goTo(index, false);
      fitCopy();
    });
    fitCopy();
    // Web fonts arrive later and change the line widths
    if (document.fonts) {
      document.fonts.addEventListener('loadingdone', fitCopy);
      document.fonts.ready.then(fitCopy);
    }

    goTo(0, false);
    startAutoplay();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-fs2-section]:not([data-fs2-ready])');
    roots.forEach(function (root) {
      root.setAttribute('data-fs2-ready', '');
      root.querySelectorAll('[data-fs2-drag-track]').forEach(initDragTrack);
      root.querySelectorAll('[data-fs2-swiper]').forEach(initSwiper);
      root.querySelectorAll('[data-fs2-variant]').forEach(initVariantPicker);
      initViewMore(root);
      root.querySelectorAll('[data-fs2-blog-carousel]').forEach(initBlogCarousel);
      initTrust(root);
    });
  }

  window.FallSale2 = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
